export default [
    {
        path: 'longs',
        component: () => import('@/pages/isle/shop/longs')
    },
    {
        path: 'suipian',
        component: () => import('@/pages/isle/shop/suipian/suipian.vue')
    },
    {
        path: 'ability',
        component: () => import('@/pages/isle/shop/ability')
    },
    {
        path: 'clan_s',
        component: () => import('@/pages/isle/shop/clan')
    },
    {
        path: 'gift',
        component: () => import('@/pages/isle/shop/gift')
    },
    {
        path: 'texiao',
        component: () => import('@/pages/isle/shop/texiao')
    },
    {
        path: 'skins',
        component: () => import('@/pages/isle/shop/skins')
    },
    {
        path: 'super',
        component: () => import('@/pages/isle/shop/super')
    },
    {
        path: 'color',
        component: () => import('@/pages/isle/shop/color')
    },
    {
        path: 'colorname',
        component: () => import('@/pages/isle/shop/colorname')
    }
];